<template>
    <div class="main_user">
        <nav-bar></nav-bar>
      <router-view></router-view>
    </div>
</template>

<style>
    #main_user {
        width: 100%;
        height: 100%;
        top: 0;
    }
</style>
<script>
    import NavBar from './NavBar.vue'

export default {
  name: 'User',
  components:{ NavBar}
}
</script>